import React, { FC } from 'react';
import { PROJECTS_NAVBAR_TEMPLATE } from 'helpers/constants/ccs';
import { generateNavLinkActiveClassName } from 'helpers/functions/commons';
import { NavLink } from 'react-router-dom';
import { useAppSelector } from 'hooks/redux';
import { hasModuleAccess } from 'helpers/functions/licenseHelpers';
import './navbar.scss';

export const ProjectsNavbar: FC = () => {
    const { licenseInfo } = useAppSelector((state) => state.userStateSlice);

    // Module requirements for each tab
    const moduleRequirements = {
        'ccs': 'ccs_module',
        'analogue': 'analogue_finder'
    };

    // Filter navigation items based on module access
    const accessibleNavItems = PROJECTS_NAVBAR_TEMPLATE.filter(({ path }) => {
        const requiredModule = moduleRequirements[path as keyof typeof moduleRequirements];
        
        if (!requiredModule) {
            return true; // If no module requirement specified, show by default
        }
        
        return hasModuleAccess(licenseInfo, requiredModule);
    });

    return (
        <div className='projects-nav'>
            {
                accessibleNavItems.map(({ title, path, disabled }) => {
                    const absolutePath = `/projects/${path}`;
                    
                    return (
                            <NavLink
                                key={path} 
                                to={absolutePath}
                                className={generateNavLinkActiveClassName}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    
                                    if (disabled) {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                <div title={disabled ? 'Coming soon.' : ''} className={disabled ? 'disabledNav' : ''} >
                                    {title}
                                </div>
                            </NavLink>
                    )
                })
            }
        </div>
    )
}